import { render, staticRenderFns } from "./RelationShipPanel.vue?vue&type=template&id=1f90d455&scoped=true&lang=pug&"
import script from "./RelationShipPanel.vue?vue&type=script&lang=js&"
export * from "./RelationShipPanel.vue?vue&type=script&lang=js&"
import style0 from "./RelationShipPanel.vue?vue&type=style&index=0&id=1f90d455&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f90d455",
  null
  
)

export default component.exports